import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config'
    })
  },
  methods: {
    initHotjar () {
      if (!this.portalConfigurations.integrations) {
        return
      }

      if (!this.portalConfigurations.integrations.hotjarTrackingCode) {
        return
      }

      this.load(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=', null, null, this.portalConfigurations.integrations.hotjarTrackingCode)
    },
    load (h, o, t, j, a, r, trackingCode) {
      h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) }
      h._hjSettings = { hjid: trackingCode, hjsv: 6 }
      a = o.getElementsByTagName('head')[0]
      r = o.createElement('script'); r.async = 1
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
      a.appendChild(r)
    }
  }
}
